module.exports = __webpack_public_path__ + "res/dummy_guess.3a7ccfe53f03bfebf9a7258b05dfa4d0.png";